/* eslint-disable complexity */
import i18next from "i18next"
import React, { useEffect, useState } from "react"

import { useApiContext } from "~/api"
import { DocumentType } from "~/api/types/DocumentsElements"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Tab, Tabs as TabsWrapper } from "~/components/Tabs/Tabs"

import { Cell, TopCell } from "../Cells/Cells"
import styles from "./index.module.css"

type DocsByYear = {
  year: string
  docs: DocumentType[]
}

type DocsByQuarter = {
  year: string
  docs: DocsByQuarterElement[]
}

type DocsByQuarterElement = {
  quarter: string
  quarterDocs: DocumentType[]
}

const reduceDocsByYear = (items: DocumentType[]): DocsByYear[] => {
  return items
    .reduce((prev: DocsByYear[], curr) => {
      const year = curr.year ? curr.year.trim() : curr.year
      const currentYear = prev.find((el) => el.year === year)

      if (!currentYear) {
        prev.push({ year, docs: [curr] })
      } else {
        prev.find((el) => el === currentYear)?.docs.push(curr)
      }

      return prev
    }, [])
    .sort((a, b) => (a.year < b.year ? 1 : -1))
}

const reduceDocsByQuarter = (items: DocumentType[]): DocsByQuarter[] => {
  const docsByYear = reduceDocsByYear(items)
  const docsByQuarter: DocsByQuarter[] = []

  docsByYear.forEach((docByYear) => {
    const year = docByYear.year ? docByYear.year.trim() : docByYear.year
    const docs = docByYear.docs
      .reduce((prev: DocsByQuarterElement[], curr) => {
        const quarter = curr.quarter
        const currentQuarter = prev.find((el) => el.quarter === quarter)

        if (!currentQuarter) {
          prev.push({ quarter, quarterDocs: [curr] })
        } else {
          prev.find((el) => el === currentQuarter)?.quarterDocs.push(curr)
        }

        return prev
      }, [])
      .sort((a, b) => (a.quarter < b.quarter ? 1 : -1))

    docsByQuarter.push({ year, docs })
  })

  return docsByQuarter
}

export const Tabs: React.FC = () => {
  const [showSecretLinks, setShowSecretLinks] = useState(false)
  const secret =
    "bd2b1aaf7ef4f09be9f52ce2d8d599674d81aa9d6a4421696dc4d93dd0619d682ce56b4d64a9ef097761ced99e0f67265b5f76085e5b0ee7ca4696b2ad6fe2b2"
  const currLang = i18next.language

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)

    if (params.get("secret") === secret) {
      setShowSecretLinks(true)
    }
  }, [])

  const QUARTERS_NAMES: { [key: string]: string } = {
    q1: currLang === "ru" ? "I квартал" : "I quarter",
    q2: currLang === "ru" ? "II квартал" : "II quarter",
    q3: currLang === "ru" ? "III квартал" : "III quarter",
    q4: currLang === "ru" ? "IV квартал" : "IV quarter",
  }

  const { items } = useApiContext("/documents/elements")

  if (!items || items.length === 0) {
    return null
  }

  const isQuarter = items.find((item) => item.quarter)
  const documents = isQuarter ? reduceDocsByQuarter(items) : reduceDocsByYear(items)
  const lastYear = documents.sort((a: DocsByYear | DocsByQuarter, b: DocsByYear | DocsByQuarter) =>
    a.year < b.year ? 1 : -1,
  )[0].year

  return (
    <div className={styles.Wrapper}>
      {/* TODO: Оставить несколько табов, остальные скрыть в кнопку ещё */}
      <TabsWrapper
        className={styles.Tabs}
        likeSelect="XsMax"
        // TODO: Перевести
        placeholder="Год"
        selectedTabId={lastYear}
      >
        {isQuarter &&
          (documents as DocsByQuarter[]).map(({ year, docs }) => (
            <Tab key={year} className={styles.Tab} id={year} title={year}>
              {docs.map(({ quarter, quarterDocs }) => (
                <div key={quarter} className={styles.Items}>
                  {quarter && (
                    <Heading as="div" className={styles.Quarter} like="h2">
                      <Raw html={QUARTERS_NAMES[quarter]} />
                    </Heading>
                  )}

                  <TopCell />

                  {quarterDocs.map(({ id, date, file, link, name, secret }) => {
                    if (!showSecretLinks && secret) return

                    return <Cell key={id} date={date} file={file} link={link} name={name} />
                  })}
                </div>
              ))}
            </Tab>
          ))}

        {!isQuarter &&
          (documents as DocsByYear[]).map(({ year, docs }) => (
            <Tab key={year} className={styles.Tab} id={year} title={year}>
              <div className={styles.Items}>
                <TopCell />

                {docs.map(({ id, date, file, link, name, secret }) => {
                  if (!showSecretLinks && secret) return

                  return <Cell key={id} date={date} file={file} link={link} name={name} />
                })}
              </div>
            </Tab>
          ))}
      </TabsWrapper>
    </div>
  )
}
